import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import Model from "@ckeditor/ckeditor5-ui/src/model";

import {
  createDropdown,
  addListToDropdown,
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";
import Collection from "@ckeditor/ckeditor5-utils/src/collection";

import imageIcon from "@ckeditor/ckeditor5-core/theme/icons/image.svg";

export default class BoxDropdown extends Plugin {
  static get pluginName() {
    return "BoxDropdown";
  }

  init() {
    const editor = this.editor;
    const t = editor.t;
    const defaultTitle = t("Add image");
    const dropdownTooltip = t("Image");

    // Register UI component
    editor.ui.componentFactory.add("boxDropdown", (locale) => {
      const dropdownView = createDropdown(locale);

      dropdownView.set({
        label: "Image",
        tooltip: true,
      });
      dropdownView.buttonView.set({
        label: "Ajouter un box",
        icon: imageIcon,
        tooltip: true,
        isOn: false,
        withText: true,
      });
      dropdownView.extendTemplate({
        attributes: {
          class: ["ck-image-dropdown"],
        },
      });

      // The collection of the list items.
      const items = new Collection();

      items.add({
        type: "button",
        model: new Model({
          label: "Box 1",
          id: "box1",
          withText: true,
          withIcon: true,
          icon: imageIcon,
        }),
      });

      items.add({
        type: "button",
        model: new Model({
          label: "Box 2",
          id: "box2",
          withText: true,
          withIcon: true,
          icon: imageIcon,
        }),
      });

      // Create a dropdown with a list inside the panel.
      addListToDropdown(dropdownView, items);
      dropdownView.on("execute", (eventInfo) => {
        const { id, label } = eventInfo.source;

        if (id === "box1") {
          console.log("Object (box1):", label);
          editor.execute("insertSimpleBox1");
        } else if (id === "box2") {
          console.log("Object (box2):", label);
          editor.execute("insertSimpleBox");
        }
      });
      return dropdownView;
    });
  }
}
